import { FC } from 'react';

import { NftDetails as NftDetialsContainer } from '../../containers/NftDetails';

export const Nft: FC = () => {
  return <NftDetialsContainer />;
};
